import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const IdealMembersInputContainer = styled.div`
  height: 66px;
  border-radius: 30px;
  padding: 0 0.5rem 0 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${palette.white};
  box-sizing: border-box;
  overflow: visible;
  position: relative;
  border: 1px solid ${palette.text};

  @media screen and (max-width: ${layout.sm}) {
    height: 60px;
    margin-top: 1rem;
    padding: 0 0.75rem 0 1rem;
  }
`;

export const InputError = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
`;

interface StyledInputProps {
  fontSize?: string;
}

export const StyledInput = styled.input<StyledInputProps>`
  text-align: left;
  background-color: ${palette.white};
  font-size: ${({ fontSize }) => fontSize || '1.25rem'};
  width: 100%;
  height: 100%;
  border: 0;
  box-sizing: border-box;
  border-radius: 15px;
  /* Remove prefilled input color */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px ${palette.white} inset !important;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${palette.lightGrayBright};
  }

  @media screen and (max-width: ${layout.sm}) {
    font-size: 1rem;
  }
`;

interface PaperAirplaneButtonProps {
  hasIcon?: boolean;
  backgroundColor?: string;
  borderColor?: string;
}

export const PaperAirplaneButton = styled.button<PaperAirplaneButtonProps>`
  border: 1px solid ${({ borderColor }) => borderColor || palette.accentBlue};
  background: ${({ backgroundColor }) => backgroundColor || palette.accentBlue};
  cursor: pointer;
  height: 50px;
  display: grid;
  justify-content: space-around;
  align-items: center;
  display: grid;
  grid-template-columns: ${({ hasIcon }) => (hasIcon ? 'auto 20px' : 'auto')};
  grid-column-gap: 10px;
  padding: 10px 25px;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
  border-radius: 30px;

  @media screen and (max-width: ${layout.sm}) {
    display: none;
  }

  > p {
    white-space: nowrap;
  }
`;
